import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DashboardHomeRouting } from "app_dashboard/pages/home/dashboard-home.routing";
import { DashboardHomeComponent } from "app_dashboard/pages/home/dashboard-home.component";
import { CardModule } from "libraries/ui_card/card.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NotificationModule } from "libraries/component/notification/notification.module";
import {
    IconNameToDefinitionModule
} from "libraries/pipes/icon-name-to-definition/icon-name-to-definition.module";
import { LocalizedModule } from "libraries/pipes/localized/localized.module";

@NgModule({
    imports: [
        CommonModule,
        DashboardHomeRouting,
        CardModule,
        FontAwesomeModule,
        NotificationModule,
        IconNameToDefinitionModule,
        LocalizedModule,
    ],
    declarations: [
        DashboardHomeComponent,
    ],
    providers: [
    ]
})
export class DashboardHomeModule {

}
